import _ from 'underscore';

import {FunctionEvalArgument} from 'notebook/tables/excess/FunctionConstants';

type Flattened1<T> = T extends Array<infer U> ? U : T;
type Flattened2<T> = T extends Array<infer U> ? Flattened1<U> : T;
type Flattened3<T> = T extends Array<infer U> ? Flattened2<U> : T;

/**
 * Flattens a list of function arguments into primitives.
 */
export default function <T extends FunctionEvalArgument = FunctionEvalArgument>(
  values: Array<T>
): Array<Flattened3<T>> {
  // We only need to flatten 3 levels so that Array<Range<Array<string>>> = Array<Array<Array<Array<string>>>>
  // becomes Array<string>.
  return _.chain(values).flatten().value() as Array<Flattened3<T>>;
}
